import { render, staticRenderFns } from "./PythonEditor.vue?vue&type=template&id=466152ba&scoped=true&"
import script from "./PythonEditor.vue?vue&type=script&lang=js&"
export * from "./PythonEditor.vue?vue&type=script&lang=js&"
import style0 from "./PythonEditor.vue?vue&type=style&index=0&id=466152ba&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466152ba",
  null
  
)

export default component.exports